import { Component, Input, OnInit } from '@angular/core';
import { DbBasic } from 'src/lib/fliko/types/nestedKey.type';
import { RWDService } from 'src/app/view/user-context/services/rwd.service';
import { TemplateService } from '../../services/template-service/template.service';
import { ContainerColor } from '../avatar/avatar.component';

@Component({
  selector: 'app-two-column-page',
  templateUrl: './two-column-page.component.html',
  styleUrls: ['./two-column-page.component.scss']
})
export class TwoColumnPageComponent implements OnInit {
  @Input() loaded = false;
  @Input() selected: DbBasic = false;
  @Input() bgColor: ContainerColor = 'primary-lighter';

  constructor(public rwdService: RWDService, public templateService: TemplateService) {}

  ngOnInit(): void {}
}
